import * as React from 'react';
import { motion } from 'framer-motion';
import andreia from '../../../assets/logo_andreia.avif';
import thalgo from '../../../assets/logo-thalgo.png';
import pearl from '../../../assets/logo-pearl-rose.png';
// Define interface for partner logo data
interface PartnerLogo {
  id: number;
  name: string;
  url: string; // Should be the path to the actual logo later
}


const Partners: React.FC = () => {
  // Placeholder data matching the design (including duplicates)
  const partnerLogos: PartnerLogo[] = [
    { id: 1, name: 'Cotril', url: 'https://cotril.it/wp-content/uploads/2022/01/logo-cotril-black.svg' },
    { id: 2, name: 'Thalgo', url: thalgo },
    { id: 3, name: 'Andreia', url: andreia },
    { id: 4, name: 'Pearl Rose Luxury Cosmetics', url: pearl },
  ];

  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <motion.section
      className="py-16 lg:py-24 bg-gradient-to-b from-white from-20% sm:from-30% to-zinc-400 text-center"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={sectionVariants}
    >
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-4xl lg:text-5xl text-dark mb-10 lg:mb-12"
           variants={itemVariants}
        >
          Parceiros
        </motion.h2>
        <motion.div
          className="grid sm:grid-cols-2 lg:grid-cols-4 justify-items-center items-center gap-x-12 gap-y-6 lg:gap-x-16 lg:gap-y-10 max-w-4xl mx-auto"
          variants={sectionVariants} // Apply stagger to logos
        >
          {partnerLogos.map((logo) => (
            <motion.div
              key={logo.id}
              className="partner-logo-item" // Keep class if needed for external refs, or remove
              variants={itemVariants}
              title={logo.name} // Add title for accessibility
            >
              <motion.img
                src={logo.url}
                alt={`${logo.name} Logo`}
                className="max-w-32 sm:max-w-48 object-contain aspect-[1.5] filter grayscale brightness-0"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 100 }}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Partners; 